const PointCriterion = () =>
  import(
    /* webpackChunkName: "base-info-feedback-point-criterion" */ '@/pages/base-info/feedback/point-criterion/index.vue'
  )
const CreatePointCriterion = () =>
  import(
    /* webpackChunkName: "base-info-feedback-point-criterion" */ '@/pages/base-info/feedback/point-criterion/create.vue'
  )
const EditPointCriterion = () =>
  import(
    /* webpackChunkName: "base-info-feedback-point-criterion" */ '@/pages/base-info/feedback/point-criterion/edit.vue'
  )

export default {
  path: 'point-criterion',
  meta: {
    label: 'feedbackPointCriterion',
    auth: 'pointCriterion'
  },
  component: {
    name: 'PointCriterion',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoFeedbackPointCriterion',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: PointCriterion
    },
    {
      name: 'BaseInfoCreateFeedbackPointCriterion',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreatePointCriterion
    },
    {
      name: 'BaseInfoEditFeedbackPointCriterion',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditPointCriterion,
      props: true
    }
  ]
}
